var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7900;}.cls-2{fill:#eb5b00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.35,115.17c.89-.02,2.08.02,2.97,0,0,1.67-1.41,3.57-2.71,3.97.89,0,1.79-.01,2.68-.02v5.49h-10.8v-5.49c.47,0,.93-.01,1.4-.02.65.04,2.09.03,3.64-.77,2.36-1.21,2.61-2.62,2.82-3.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.33,113.92h-.04s-16.07-.14-16.07-.14l.07-8.3,16.05.14c4.11,0,7.46-3.36,7.46-7.47s-3.35-7.47-7.47-7.47h-10.71v-8.3h10.71c8.7,0,15.77,7.08,15.77,15.77s-7.08,15.77-15.77,15.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.18,113.95h-.04s-16.07-.14-16.07-.14l.07-8.3,16.05.14c4.11,0,7.46-3.36,7.46-7.47s-3.35-7.47-7.47-7.47h-2.5v3.9h-8.3v-12.2h10.8c8.7,0,15.77,7.08,15.77,15.77s-7.08,15.77-15.77,15.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.52,113.78h-22.45c-4,0-7.25-3.25-7.25-7.25v-12.94c0-6.26,5.1-11.36,11.36-11.36h15.72v20.54h-8.3v-12.25h-7.43c-1.69,0-3.06,1.37-3.06,3.06v11.89h21.4v8.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.52,125.83h-7.68v-8.3h7.68c2.84,0,9.5-2.31,9.5-5.15v-2.76h8.3v2.76c0,7.41-10.39,13.44-17.8,13.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.06,126h-12c-7.81,0-14.16-6.35-14.16-14.16v-13.67h8.3v13.67c0,3.23,2.63,5.86,5.86,5.86h12c4.36,0,7.9-3.55,7.9-7.9h8.3c0,8.93-7.27,16.2-16.2,16.2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "152.14 81.28 126.62 81.28 126.62 78.35 152.14 69.88 152.14 81.28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.95.03c5.21-.1,12.19.1,17.4,0,0,9.8-8.28,20.94-15.88,23.29,5.24-.04,10.47-.08,15.71-.12v42.77h-63.36V23.22c2.73-.04,5.46-.08,8.2-.12,3.8.25,12.25.17,21.36-4.49C102.24,11.5,103.68,3.22,104.95.03Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.82,
    y: 23.22,
    width: 63.36,
    height: 42.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullVertical);
export default __webpack_public_path__ + "static/media/full-vertical.e239a230e049212a89523b7d0f1d25ac.svg";
export { ForwardRef as ReactComponent };